<template>
<div class="info">
	<Form :label-width="120" class="mt15">
		<FormItem label="保障凭证号：" class="w600">
	        {{info.guaranteeNo}}
			<a :href="info.electronicPolicyUrl" v-if="info.electronicPolicyUrl" target="_blank" class="ml20">查看保单</a>
	    </FormItem>
	    <FormItem label="保障状态：" class="w600">
	        {{info.effectiveStatusDesc}}
	    </FormItem>
		<FormItem label="保单起期：" class="w600">
			{{info.effectiveDateStart}}
		</FormItem>
		<FormItem label="保单止期：" class="w600">
			{{info.effectiveDateEnd}}
		</FormItem>
		<FormItem label="保费：" class="w600">
			{{info.premium}}元
		</FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
	},
	methods:{
		// renew () {
		// 	this.$router.push(`/installer/fillin-order/${this.$route.params.id}?hrCode=${this.info.hrCode}`)
		// }
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/PolicyBasicInfoForCommon.vue